import CONST from './const'

const {
  LOCAL_STORAGE_SCORE_KEY,
  RESULT: { TIE, USER, COMPUTER },
  WHO_BEATS_WHO,
  DIFFICULTY
} = CONST

const getUpdatedScore = (score, result) => {
  if (result === TIE) {
    return score
  }

  let currentScore = parseInt(score),
    updatedScore = result === USER ? currentScore + 1 : currentScore - 1

  // save to local storage
  localStorage && localStorage.setItem(LOCAL_STORAGE_SCORE_KEY, updatedScore)
  return updatedScore
}

const getResult = (userChose, computerChose, difficulty) => {
  let result = TIE,
    gameWinning = WHO_BEATS_WHO[difficulty]

  if (gameWinning[computerChose].includes(userChose)) result = COMPUTER
  else if (gameWinning[userChose].includes(computerChose)) result = USER

  return result
}

const getResultText = (result) => {
  if (result === TIE) return 'Its a Tie 🤜🏻🤛🏻'
  if (result === USER) return 'You won 🥳'
  if (result === COMPUTER) return 'You lose 🤯'
}

const getRandomValue = (arrayOfValues) => {
  const randomIndex = Math.floor(Math.random() * arrayOfValues.length)
  return arrayOfValues[randomIndex]
}

const isNovice = (difficulty) => difficulty === DIFFICULTY.NOVICE

const getSavedScore = () => (localStorage && localStorage.getItem(LOCAL_STORAGE_SCORE_KEY)) || 0

export { getUpdatedScore, getResult, getRandomValue, getResultText, isNovice, getSavedScore }
